import { Injectable } from '@angular/core';
import { AbstractControl, FormBuilder, ValidatorFn, Validators } from '@angular/forms';
import { ReferenceArea } from '../models/reference-area';
import { ValidateUniqueField } from '../../../shared/validators/uniqueField.validator';
import { ValidateInputLength } from '../../../shared/validators/inputLength.validator';
import { ValidateEnumField } from '../../../shared/validators/enum.validator';
@Injectable({
  providedIn: 'root'
})
export class ReferenceAreaEditFormService {
  constructor(
    private fb: FormBuilder
  ) {
  }
  generate(otherReferenceAreas: ReferenceArea[], allowedTypes: string[]) {
    return this.fb.group({
      projectId: ['', Validators.required],
      name: ['', [Validators.required, ValidateInputLength(1, 255)]],
      description: ['', [Validators.required, ValidateInputLength(1, 128)]],
      stationCode: ['', [Validators.required, ValidateInputLength(1, 64), ValidateUniqueField<ReferenceArea>(otherReferenceAreas, 'stationCode')]],
      abbreviation: ['', [Validators.required, ValidateUniqueField<ReferenceArea>(otherReferenceAreas, 'abbreviation'), ValidateInputLength(2, 5)]],
      type: ['', [Validators.required, ValidateEnumField(allowedTypes)]],
      latLongList: ['', [Validators.required, areaValidator(3)]]
    });
  }
}

 /**
 * Validate an area is entered in the correct format.
 * A minimum of 3 geo-positions are required.
 * A geo-position will be a string: latitude,longitude
 * geo-positions should contain a single space between
 * Example:
 * 48.858093,2.294694 48.857000,2.297000 48.857000,2.291000
 */
 export function areaValidator(positionLength: number): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const area: string = control.value;
    const positions = area && area.split(" ");

    if (positions) {
      if (positions.length < positionLength) {
        return {
          minPositions: positionLength,
          actualPositions: positions.length
        };
      } 
  
      for (let position of positions) {
        const positionSplit = position.split(",");
  
        if (positionSplit.length != 2) {
          return {cannotParsePosition: position};
        } else {
  
          if (positionSplit[0] === "") {
            return {latitudeMissing: position};
          }
          if (positionSplit[1] === "") {
            return {longitudeMissing: position};
          }
  
          const latitude = parseInt(positionSplit[0]);
          const longitude = parseInt(positionSplit[1]);
  
          if (isNaN(latitude) || (latitude < -90 || latitude > 90)) {
            const latitudeVal = isNaN(latitude) ? positionSplit[0] : latitude;
            return {latitudeInvalid: latitudeVal};
          }
  
          if (isNaN(longitude) || (longitude < -180 || longitude > 180)) {
            const longitudeVal = isNaN(longitude) ? positionSplit[1] : longitude;
            return {longitudeInvalid: longitudeVal};
          }
        }
      }
      return null;
    } else {
      return null
    }
  }
}
